// Shopify products slider
const shopifyProductsSlider = $('.products-slider');

shopifyProductsSlider.slick({
  slidesToShow: 7,
  slidesToScroll: 6,
  infinite: false,
  centerMode: false,
  variableWidth: true,
  draggable: true,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 5,
      },
    },
  ],
});
